exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mainContainer{background-color:rgba(34,34,34,.541);color:#fff;padding:1rem;border-radius:1rem;display:flex;flex-direction:column;align-items:center;justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/data/graphs/custom_tooltip.scss
// module id = 1275
// module chunks = 0